import React, { SVGProps } from 'react';

const EyeIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M11.5191 3.44204C10.3049 1.56866 8.23186 0.429273 5.99948 0.408329C3.76712 0.429273 1.69412 1.56866 0.479908 3.44204C-0.159969 4.3811 -0.159969 5.61609 0.479908 6.55518C1.69344 8.42971 3.76656 9.57028 5.99951 9.59191C8.23186 9.57096 10.3049 8.43158 11.5191 6.55819C12.1603 5.61843 12.1603 4.38179 11.5191 3.44204ZM10.2766 5.70376C9.34962 7.17413 7.73766 8.07121 5.99948 8.0841C4.26133 8.07123 2.64936 7.17413 1.72232 5.70376C1.43331 5.27917 1.43331 4.72104 1.72232 4.29648C2.64934 2.8261 4.26131 1.92903 5.99948 1.91614C7.73763 1.929 9.3496 2.8261 10.2766 4.29648C10.5656 4.72104 10.5656 5.27917 10.2766 5.70376Z"
                fill="currentColor"
            />
            <path
                d="M5.99966 7.01043C7.10998 7.01043 8.01007 6.11034 8.01007 5.00002C8.01007 3.88971 7.10998 2.98962 5.99966 2.98962C4.88935 2.98962 3.98926 3.88971 3.98926 5.00002C3.98926 6.11034 4.88935 7.01043 5.99966 7.01043Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default EyeIcon;
